import { useToast } from './use-toast';

export const useSnackbar = () => {
  const { toast } = useToast();

  const success = (message: string): void => {
    toast({
      title: message,
      variant: 'default',
    });
  };

  const warning = (message: string): void => {
    toast({
      title: message,
      variant: 'warning',
    });
  };

  const error = (message: string): void => {
    toast({
      title: message,
      variant: 'destructive',
    });
  };

  return {
    errorSnackbar: error,
    successSnackbar: success,
    warningSnackbar: warning,
  };
};
